const maxCharacterToDisplay = 9;

export const limitProviderName = (providerName: string) => {
  return providerName!.length < maxCharacterToDisplay
    ? providerName
    : providerName?.substring(0, maxCharacterToDisplay - 1) + '...';
};
